/* @ngInject */
export default function ($scope, LayoutService, FormVersions, toastr, $state, $stateParams, AuthService) {
	AuthService.redirectIfUnauthorized('forms-management-view', 'splash.home');

	$scope.formId    = $stateParams.formId;
	$scope.versionId = $stateParams.versionId;
	$scope.loading   = true;

	$scope.refresh = () => {
		$scope.loading = true;

		FormVersions.one($scope.versionId)
		            .get({
			            include: 'form,elements',
		            })
		            .then((version) => {
			            $scope.version = version;
			            $scope.loading = false;

			            $scope.updateLayout($scope.version.form.title, $scope.version.version);
		            })
		            .catch((error) => {
			            toastr.clear();
			            toastr.error('There was an error while loading this version, please try again.', 'Error');

			            $state.go('staff.forms.management.view', {
				            formId: $scope.formId,
			            });

			            $scope.loading = false;
		            });
	};

	$scope.updateLayout = (formName = 'Loading...', versionName = 'Loading...') => {
		LayoutService.reset();

		LayoutService.setTitle([
			versionName,
			formName,
			'Management',
			'Forms',
		]);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.forms.root',
				             displayName: 'Forms',
			             },
			             {
				             route:       'staff.forms.management.root',
				             displayName: 'Management',
			             },
			             {
				             route:       `staff.forms.management.view({ formId: "${$scope.formId}" })`,
				             displayName: formName,
			             },
			             {
				             route:       `staff.forms.management.versions.view({ formId: "${$scope.formId}", versionId: "${$scope.versionId}" })`,
				             displayName: versionName,
			             },
		             ]);

		let updateButton = LayoutService.getPageHeader()
		                                .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

		let newButtonText = 'New Version';

		if (versionName !== 'Loading...') {
			newButtonText += ` From ${versionName}`;
		}

		let newButton = LayoutService.getPageHeader()
		                             .setActionButton(`<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-plus"></i> ${newButtonText}</button>`);

		LayoutService.getPageHeader()
		             .onClicked(updateButton, $scope.refresh);

		LayoutService.getPageHeader()
		             .onClicked(newButton, () => {
			             $state.go('staff.forms.management.versions.edit', {
				             formId:    $scope.formId,
				             versionId: $scope.versionId,
			             });
		             });
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/forms/management/versions/view/controller.js